import { initFirebase } from '../firebase'
import { onAuthStateChanged, signInAnonymously, signOut as firebaseSignOut } from 'firebase/auth'

const { auth } = initFirebase()

export class FirebaseAuthService {
  constructor() {
    this.initializeAuth()
  }

  async initializeAuth() {
    try {
      onAuthStateChanged(auth, async (user) => {
        if (!user) {
          await this.signInAnonymously()
        }
      })
    } catch (error) {
      console.error('Error initializing auth:', error)
    }
  }

  async signInAnonymously() {
    try {
      const userCredential = await signInAnonymously(auth)
      return {
        uid: userCredential.user.uid,
        isAnonymous: userCredential.user.isAnonymous
      }
    } catch (error) {
      console.error('Error signing in anonymously:', error)
      throw error
    }
  }

  async fetchOrCreateUser() {
    try {
      let user = auth.currentUser

      if (!user) {
        await this.signInAnonymously()
        user = auth.currentUser
      }

      return {
        uid: user.uid,
        isAnonymous: user.isAnonymous,
        model: {
          uid: user.uid,
          properties: {}
        }
      }
    } catch (error) {
      console.error('Error fetching/creating user:', error)
      throw error
    }
  }

  async signOut() {
    try {
      await firebaseSignOut(auth)
    } catch (error) {
      console.error('Error signing out:', error)
      throw error
    }
  }
} 